import errorMiddleware from './error';
import { fetchMiddleware } from './fetch';
import { optionsMiddleware } from './options';
import updateMiddleware from './update';

export default [optionsMiddleware, fetchMiddleware, errorMiddleware, updateMiddleware];
